import { UserPermissions } from '@agroone/entities'

export const OFFLINE_PERMISSIONS_CONFIG: UserPermissions[] = [
  UserPermissions.CROP_MODULE_ACCESS,
  UserPermissions.FARMS_VIEW,
  UserPermissions.CROPS_VIEW,
  UserPermissions.SCOUTINGS_EDIT,
  UserPermissions.PLANTING_EDIT,
]
